"use strict";

var ROLES = require('@rss/common/dist/constant/core/roles.constant');
var jwt = require('jsonwebtoken');
module.exports = /*@ngInject*/function ($cookies, $location, ENV, ProfileService) {
  var hasDevtoolAccess = function hasDevtoolAccess() {
    var isDeveloper = ProfileService.hasRole(ROLES.DEVELOPER);
    var token = jwt.decode($cookies.get('authtoken') || '');
    return ENV.toLowerCase() !== 'production' && (isDeveloper || token && token.orig_sub);
  };
  var service = {
    active: '',
    setActive: function setActive(active) {
      service.active = active;
    },
    getMenu: function getMenu() {
      var menuItems = [];
      if (ProfileService.isAdmin() || ProfileService.isInspector() || ProfileService.hasManagerInspection()) {
        menuItems.push({
          title: 'Start Inspection',
          link: '#!/report-create'
        });
      }
      if (ProfileService.hasRoleInInspect()) {
        menuItems.push({
          title: 'Inspection Reports',
          link: '#!/report'
        });
      }
      if (ProfileService.isAdmin() || ProfileService.isSuperUser()) {
        menuItems.push({
          title: 'Management',
          link: '#!/management'
        });
      }
      if (ProfileService.isSuperUser()) {
        menuItems.push({
          title: 'Service Desk',
          link: '#!/service-desk'
        });
        menuItems.push({
          title: 'Resources',
          link: '#!/resources'
        });
      }
      if (hasDevtoolAccess()) {
        menuItems.push({
          title: 'Developer Tools',
          link: "".concat($location.host().includes('localhost') ? 'http://localhost:3000' : '', "/developer/spoofing")
        });
      }
      return menuItems;
    }
  };
  return service;
};